import { render } from "./RelatedArticleBox.vue?vue&type=template&id=50583583&scoped=true"
import script from "./RelatedArticleBox.vue?vue&type=script&lang=js"
export * from "./RelatedArticleBox.vue?vue&type=script&lang=js"

import "./RelatedArticleBox.vue?vue&type=style&index=0&id=50583583&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50583583"

export default script